import { EventPageVisibility } from '@graphql/generated-base';
import type { WebsitePage } from '@shared/hooks/useWebsitePagesByRole';
import type { WebsitePrivacyVisibility } from './useWebsitePrivacy.types';

const ROLLUPS: ReadonlySet<string> = new Set<WebsitePrivacyVisibility>(['public', 'private', 'custom', 'hidden']);

/** The pages the rollup counts: those guests can open on their own (V1 lists only those). */
export const countedPages = (pages: ReadonlyArray<WebsitePage>): ReadonlyArray<WebsitePage> => pages.filter(page => page.path !== null || page.hidden);

/** Carbon's rollup over the pages (`SiteVisibilityRollup`), for a V1 event. */
export const rollUpVisibility = (pages: ReadonlyArray<WebsitePage>): WebsitePrivacyVisibility => {
  if (!pages.length) return 'public';
  const protectedCount = pages.filter(page => page.visibility === EventPageVisibility.passwordProtected).length;
  if (protectedCount === pages.length) return 'private';
  if (protectedCount > 0) return 'custom';
  if (pages.every(page => page.hidden)) return 'hidden';
  return 'public';
};

/** The V2 site's own rollup when it reports one, else the pages'. */
export const toVisibility = (siteVisibility: string | null | undefined, pages: ReadonlyArray<WebsitePage>): WebsitePrivacyVisibility =>
  siteVisibility && ROLLUPS.has(siteVisibility) ? (siteVisibility as WebsitePrivacyVisibility) : rollUpVisibility(pages);
